module.exports = __webpack_public_path__ + "img/banner2.f89765e9.png";